import { render, staticRenderFns } from "./cars.vue?vue&type=template&id=55705ac8&scoped=true"
import script from "./cars.vue?vue&type=script&lang=js"
export * from "./cars.vue?vue&type=script&lang=js"
import style0 from "./cars.vue?vue&type=style&index=0&id=55705ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55705ac8",
  null
  
)

export default component.exports